import { Routes } from '@angular/router';
import { authLayoutRoutes } from '@app/layouts/auth-layout/auth-layout.routes';
import { mainLayoutRoutes } from '@app/layouts/main-layout/main-layout.routes';
import { authGuard, rootRedirectGuard } from '@app/core';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('@app/layouts/auth-layout/auth-layout').then((c) => c.AuthLayoutComponent),
    children: authLayoutRoutes,
  },
  // Area setelah login. Prefix dibedakan per peran (/admin, /vendor), tapi komponennya
  // SAMA — shell-nya identik dan isi menunya sudah disaring BE lewat navigation_tree/MAIN.
  // Peran disimpulkan dari /api/privilege (lihat PrivilegeService), bukan dari URL:
  // URL di sini penanda, BUKAN penegak otorisasi.
  //
  // Jangan menyalin layout jadi admin-layout + vendor-layout — itu menggandakan shell
  // yang persis sama. Kalau nanti isi keduanya berbeda, cukup pisahkan `children`-nya.
  {
    // Guard di route induk otomatis melindungi seluruh anaknya.
    path: 'admin',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@app/layouts/main-layout/main-layout').then((c) => c.MainLayoutComponent),
    children: mainLayoutRoutes,
  },
  {
    path: 'vendor',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@app/layouts/main-layout/main-layout').then((c) => c.MainLayoutComponent),
    children: mainLayoutRoutes,
  },
  // Halaman statis CMS (Post) — PUBLIK, tanpa guard: inilah tujuan item menu
  // `navigation_tree/PUBLIC` yang ber-`navigable.type === "Post"`, yang sebelumnya tidak punya
  // alamat sama sekali dan karenanya hilang dari drawer (lihat `navigation-link.util.ts`).
  //
  // Di root, BUKAN di bawah `auth/`: BE mengirim path absolut `/pages/<slug>` untuk item Link
  // sejenis ("Integrity Pact"), jadi prefix apa pun akan membuat kedua jalur itu berbeda.
  //
  // Memakai ulang `AuthLayoutComponent` supaya halaman ini punya header, logo, dan drawer menu
  // yang sama dengan halaman pra-login — tanpa `data.authCover`, jadi shell-nya satu kolom.
  {
    path: 'pages',
    loadComponent: () =>
      import('@app/layouts/auth-layout/auth-layout').then((c) => c.AuthLayoutComponent),
    children: [
      {
        path: ':slug',
        loadComponent: () =>
          import('@shared/pages/public-page/public-page.component').then(
            (c) => c.PublicPageComponent,
          ),
        // Judul Post-nya baru diketahui setelah request selesai, sedangkan TitleStrategy
        // berjalan saat navigasi. Judul generik yang benar sejak awal lebih baik daripada
        // judul yang berkedip.
        title: 'routes.publicPage',
      },
    ],
  },
  // Root: tujuannya bergantung sesi + peran, jadi tidak bisa `redirectTo` statis —
  // guard-nya yang memutuskan (dan boleh menunggu /api/privilege). `children: []`
  // hanya pelengkap bentuk route: guard selalu mengembalikan UrlTree, tidak pernah
  // benar-benar mengaktifkan route ini.
  { path: '', pathMatch: 'full', canActivate: [rootRedirectGuard], children: [] },
  // Catch-all untuk route yang tidak dikenal (404).
  {
    path: '**',
    loadComponent: () =>
      import('@shared/pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
    title: 'routes.notFound',
  },
];
